import {forwardRef} from 'react'
import {type TextProps} from 'react-native'
import Svg, {
  Defs,
  LinearGradient,
  Path,
  type PathProps,
  Stop,
  type SvgProps,
} from 'react-native-svg'
import {Image} from 'expo-image'

import {useKawaiiMode} from '#/state/preferences/kawaii'
import {flatten, useTheme} from '#/alf'

const ratio = 92 / 92

type Props = {
  fill?: PathProps['fill']
  style?: TextProps['style']
} & Omit<SvgProps, 'style'>

export const Logo = forwardRef(function LogoImpl(props: Props, ref) {
  const t = useTheme()
  const {fill, ...rest} = props
  const gradient = fill === 'sky'
  const styles = flatten(props.style)
  const _fill = gradient
    ? 'url(#sky)'
    : fill || styles?.color || t.palette.primary_500
  // @ts-ignore it's fiiiiine
  const size = parseInt(rest.width || 32, 10)

  const isKawaii = useKawaiiMode()

  if (isKawaii) {
    return (
      <Image
        source={
          size > 100
            ? require('../../../assets/kawaii.png')
            : require('../../../assets/kawaii_smol.png')
        }
        accessibilityLabel="Taderok"
        accessibilityHint=""
        accessibilityIgnoresInvertColors
        style={[{height: size, aspectRatio: 1.0}]}
      />
    )
  }

  return (
    <Svg
      fill="none"
      // @ts-ignore it's fiiiiine
      ref={ref}
      viewBox="0 0 92 92"
      {...rest}
      style={[{width: size, height: size * ratio}, styles]}>
      {gradient && (
        <Defs>
          <LinearGradient id="sky" x1="0" y1="0" x2="0" y2="1">
            <Stop offset="0" stopColor="#0A7AFF" stopOpacity="1" />
            <Stop offset="1" stopColor="#59B9FF" stopOpacity="1" />
          </LinearGradient>
        </Defs>
      )}

      <Path
        fill={_fill}
        d="M91.996 45.2164C91.996 38.7248 86.947 33.2637 80.5585 32.5425H79.0129C72.6245 32.9546 67.5755 37.7975 67.2664 44.186C67.2664 44.5294 67.2664 44.8729 67.2664 45.2164V45.5255V45.8346C67.2664 59.745 56.4472 71.0794 42.846 71.3885C29.1417 71.3885 18.1164 60.3632 17.8073 46.4528C17.8073 42.3312 14.3039 38.7248 10.1823 38.7248C6.06072 38.7248 2.55737 42.3312 2.55737 46.4528V47.1741C2.86649 72.3158 23.1653 92.3056 47.8949 91.9965C72.6245 91.6873 92.3051 71.0794 91.996 45.8346V45.2164ZM91.996 13.274C91.996 19.9716 86.6379 25.8449 79.6312 25.8449C72.6245 25.8449 67.2664 20.3838 67.2664 13.274C67.2664 6.16425 72.6245 0.600098 79.6312 0.600098C86.6379 0.600098 91.996 6.16425 91.996 13.274ZM19.0437 24.8145C19.0437 30.0695 14.9222 34.1911 9.8732 34.1911C4.7212 34.1911 0.599609 30.0695 0.599609 24.8145C0.599609 19.6625 4.7212 15.5409 9.8732 15.5409C14.9222 15.5409 19.0437 19.6625 19.0437 24.8145Z"
      />
    </Svg>
  )
})
